const actions = require('./actions')
const reducer = require('./reducer')
const epics = require('./epics')
const selectors = require('./selectors')

module.exports = {
  actions,
  reducer,
  epics,
  selectors,
  rootReducerKey: 'setting',
}
